const Plus: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className ?? ''}>
      <path
        d="M7.33333 2V7.33333H2V8.66667H7.33333V14H8.66667V8.66667H14V7.33333H8.66667V2H7.33333Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Plus;
